/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { isMobile } from "@root/helpers/userDeviceUtils";
import ResponsiveWrapper from "../_responsive-wrapper";
import BaseInput from "../base-input";

const { v4: uuidv4 } = require("uuid");

const ColorPicker = ({ value, onChange, label, required }) => {
    const uuid = uuidv4();

    const [isMobileDevice, setIsMobileDevice] = useState(false);

    useEffect(() => {
        setIsMobileDevice(isMobile());
    }, []);
    return (
        <ResponsiveWrapper className="color-picker">
            <BaseInput
                label={label}
                required={required}
            >
                <div className={`color-picker__wrapper${
                    isMobileDevice ? " color-picker__wrapper--isMobile" : ""
                }`}
                >
                    <input
                        type="color"
                        id={uuid}
                        className="color-picker__color"
                        value={value}
                        onChange={(event) => onChange(event.target.value)}
                    />
                    <label htmlFor={uuid} className="color-picker__color-label" style={{ backgroundColor: value }} />
                    <input
                        type="text"
                        value={value}
                        onChange={(event) => onChange(event.target.value)}
                        pattern="^#[0-9A-F]{6}$|^#[0-9A-F]{3}$"
                        className="color-picker__input-text"
                        placeholder="#BABABA"
                    />
                    <label htmlFor={uuid} className="color-picker__icon" />
                </div>
            </BaseInput>
        </ResponsiveWrapper>
    );
};

export default ColorPicker;
